module.exports = __webpack_public_path__ + "static/img/16.02fea3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/16.png
// module id = I8Kl
// module chunks = 0